import { useEffect, useRef, useState } from 'react';

interface SharePanelProps {
  title: string;
  onNotify: (message: string) => void;
}

export default function SharePanel({ title, onNotify }: SharePanelProps) {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const onClickOutside = (event: MouseEvent) => {
      if (wrapRef.current && !wrapRef.current.contains(event.target as Node)) setOpen(false);
    };
    document.addEventListener('mousedown', onClickOutside);
    return () => document.removeEventListener('mousedown', onClickOutside);
  }, []);

  const shareUrl = typeof window !== 'undefined' ? window.location.href : '';

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      onNotify('链接已复制，快去分享给朋友吧');
    } catch {
      onNotify(`复制失败，可手动复制链接：${shareUrl}`);
    }
    setOpen(false);
  };

  const shareToWeibo = () => {
    const url = `https://service.weibo.com/share/share.php?title=${encodeURIComponent(title)}&url=${encodeURIComponent(shareUrl)}`;
    window.open(url, '_blank', 'noopener,noreferrer');
    setOpen(false);
  };

  return (
    <div className="relative" ref={wrapRef}>
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        className="inline-flex items-center gap-1.5 px-4 py-2 rounded-md border border-background-300 text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-600 whitespace-nowrap cursor-pointer transition-colors"
      >
        <i className="ri-share-forward-line" />
        分享
      </button>

      {open ? (
        <div className="absolute right-0 mt-2 w-44 rounded-lg border border-background-200 bg-background-50 overflow-hidden z-20 animate-fade-in">
          <button
            type="button"
            onClick={() => {
              onNotify('请使用微信「扫一扫」或复制链接在微信中打开分享');
              setOpen(false);
            }}
            className="w-full flex items-center gap-2.5 px-4 py-3 text-sm text-foreground-700 hover:bg-background-100 cursor-pointer transition-colors"
          >
            <i className="ri-wechat-line text-lg text-primary-600" />
            分享到微信
          </button>
          <button
            type="button"
            onClick={shareToWeibo}
            className="w-full flex items-center gap-2.5 px-4 py-3 text-sm text-foreground-700 hover:bg-background-100 cursor-pointer transition-colors"
          >
            <i className="ri-weibo-line text-lg text-primary-600" />
            分享到微博
          </button>
          <button
            type="button"
            onClick={copyLink}
            className="w-full flex items-center gap-2.5 px-4 py-3 text-sm text-foreground-700 hover:bg-background-100 cursor-pointer transition-colors"
          >
            <i className="ri-link-m text-lg text-primary-600" />
            复制链接
          </button>
        </div>
      ) : null}
    </div>
  );
}